import React from 'react';

import Images from '../../../../assets/images';

const CoverImage = ({ imageUrl, alt }) => {
  const fallbackImage = Images.fallbackImage;
  const imgUrl = imageUrl || fallbackImage;

  let backgroundImageValue = `linear-gradient(to top, rgba(0, 0, 0, .4), rgba(0, 0, 0, 0)), url(${imgUrl}), url(${fallbackImage})`;
  const style = {
    backgroundImage: backgroundImageValue,
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };
  return <img alt={''} aria-label={alt} style={style} />;
};

export { CoverImage };
